import type Guid from "@/app/types/common/guid";
import { reactive, readonly } from "vue";

let hintStack: Guid[] = [];

interface WizardStoreState {
  numberOfSteps: number;
  stepNumber: number;
  atLastRequiredStep: boolean;
  activeHint: Guid | null;
}

const state = reactive<WizardStoreState>({
  numberOfSteps: 0,
  stepNumber: 0,
  atLastRequiredStep: false,
  activeHint: null,
});

export default {
  state: readonly(state),
  setNumberOfSteps: (numberOfSteps: number) =>
    (state.numberOfSteps = numberOfSteps),
  updateStep: (stepNumber: number, atLastRequiredStep: boolean) => {
    state.stepNumber = stepNumber;
    state.atLastRequiredStep = atLastRequiredStep;
  },
  pushHint: (hintId: Guid) => {
    hintStack = hintStack.filter((h) => !h.equals(hintId));
    hintStack.push(hintId);
    state.activeHint = hintStack.slice(-1)[0] ?? null;
  },
  popHint: (hintId: Guid) => {
    hintStack = hintStack.filter((h) => !h.equals(hintId));
    state.activeHint = hintStack.slice(-1)[0] ?? null;
  },
};
